import { render, staticRenderFns } from "./BeaufschlagtePreisdatenAdmin.vue?vue&type=template&id=5c0f395c"
import script from "./BeaufschlagtePreisdatenAdmin.vue?vue&type=script&lang=js"
export * from "./BeaufschlagtePreisdatenAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c0f395c')) {
      api.createRecord('5c0f395c', component.options)
    } else {
      api.reload('5c0f395c', component.options)
    }
    module.hot.accept("./BeaufschlagtePreisdatenAdmin.vue?vue&type=template&id=5c0f395c", function () {
      api.rerender('5c0f395c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/BeaufschlagtePreisdatenAdmin.vue"
export default component.exports